import axios from 'axios';

const getAuthHeader = () => ({
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  }
});

export const fetchAirwayBills = async (params = {}) => {
  console.log('DEBUG: fetchAirwayBills called with params:', params);
  const response = await axios.get('/api/orders/airway-bills/', {
    ...getAuthHeader(),
    params: params
  });
  return response.data;
};

export const fetchCustomers = async (params = {}) => {
  const response = await axios.get('/api/orders/airway-bills/customers/', {
    ...getAuthHeader(),
    params
  });
  return response.data;
};

export const fetchBatches = async () => {
  const response = await axios.get('/api/orders/batches/', getAuthHeader());
  return response.data;
};

export const fetchAirwayBillBatches = async (airwayBillId) => {
  const response = await axios.get(`/api/orders/airway-bills/${airwayBillId}/batches/`, getAuthHeader());
  return response.data;
};

export const fetchBatchOrders = async (batchId) => {
  const response = await axios.get(`/api/orders/batches/${batchId}/orders/`, getAuthHeader());
  return response.data;
};

export const createAirwayBill = async (formData) => {
  console.log('Received form data in createAirwayBill:', formData);
  const processedData = { ...formData };
  console.log('Processed data being sent to server:', processedData);

  try {
    const response = await axios.post('/api/orders/airway-bills/', processedData, getAuthHeader());
    console.log('Server response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Server error response:', error.response?.data);
    throw error;
  }
};

export const createSimpleAirwayBill = async (airwayBillNumber) => {
  const response = await axios.post('/api/orders/airway-bills/', {
    airway_bill_number: airwayBillNumber
  }, getAuthHeader());
  return response.data;
};

export const updateAirwayBill = async (id, formData) => {
  console.log('Received form data in updateAirwayBill:', formData);
  const processedData = { ...formData };
  console.log('Processed data being sent to server:', processedData);

  try {
    const response = await axios.put(`/api/orders/airway-bills/${id}/`, processedData, getAuthHeader());
    console.log('Server response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Server error response:', error.response?.data);
    throw error;
  }
};

export const deleteAirwayBill = async (id) => {
  await axios.delete(`/api/orders/airway-bills/${id}/`, getAuthHeader());
};

export const assignBatches = async (airwayBillId, batchIds) => {
  await axios.post(`/api/orders/airway-bills/${airwayBillId}/assign_batches/`, {
    batch_ids: batchIds
  }, getAuthHeader());
};

export const assignAirwayBillToBatch = async (batchId, airwayBillId) => {
  await axios.post(`/api/orders/batches/${batchId}/assign_airway_bill/`, {
    airway_bill_id: airwayBillId
  }, getAuthHeader());
};

export const fetchAirwayBillOrders = async (airwayBillId, params = {}) => {
  const response = await axios.get(`/api/orders/airway-bills/${airwayBillId}/orders/`, {
    ...getAuthHeader(),
    params: {
      page: params.page,
      page_size: params.pageSize
    }
  });
  return response.data;
};

export const batchUpdateAirwayBillStatus = async (airwayBillIds, status) => {
  const response = await axios.post('/api/orders/airway-bills/batch_update_status/', {
    airway_bill_ids: airwayBillIds,
    status
  }, getAuthHeader());
  return response.data;
};

export const batchUpdateOrdersToInspection = async (orderIds) => {
  const response = await axios.post('/api/orders/batch_update_to_inspection/', {
    order_ids: orderIds
  }, getAuthHeader());
  return response.data;
};

export const updateAirwayBillOrdersStatus = async (airwayBillId, status) => {
  const response = await axios.post(`/api/orders/airway-bills/${airwayBillId}/update_orders_status/`, {
    status
  }, getAuthHeader());
  return response.data;
};

export const updateOrderFlag = async (orderId, field, value) => {
  const response = await axios.patch(`/api/orders/${orderId}/bool_field/`, {
    field,
    value
  }, getAuthHeader());
  return response.data;
};

export const batchUpdateOrderFlag = async (orderIds, field, value) => {
  const promises = orderIds.map(orderId => updateOrderFlag(orderId, field, value));
  return Promise.all(promises);
};
